import { ConsolePage } from './pages/ConsolePage';
import { ThemeProvider } from './context/ThemeContext';
import './App.scss';

function App() {
  return (
    <ThemeProvider>
      <div data-component="App">
        <ConsolePage />
      </div>
    </ThemeProvider>
  );
}

export default App;
